/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Vendor top next/previous employer, with the flow volume.
 */
export interface CompanyEmployerFlowCountSchema {
  company_id?: string | null;
  display_name?: string | null;
  role?: string | null;
  count?: number | null;
}
